import { useEffect, useState } from "react";

import { DatePicker } from "@cdkglobal/radial";
import moment, { Moment } from "moment";
import { RenderDatePickerProps } from "../../../../types";
import { getCustomBlockedCalendarDates } from "../../evaluations/customDateEvaluations/customDateEvaluations";

export default function RenderDatePicker({
  title,
  propertyKey,
  rowIndex,
  propertySubKey,
  inputValue,
  isRequired,
  error,
  message,
  isDialogField,
  isDisabled,
  evalMethod,
  selectedTabSectionKey,
  dispatch,
}: Readonly<RenderDatePickerProps>): JSX.Element {
  const dateFormat = "YYYY-MM-DD";
  const parseDateOrNull = (val: string) => {
    const parsedDate = moment(val, dateFormat, true);
    return parsedDate.isValid() ? parsedDate : null;
  };

  const [date, setDate] = useState<Moment | null>(() =>
    parseDateOrNull(inputValue as string),
  );

  useEffect(() => {
    setDate(parseDateOrNull(inputValue as string));
  }, [inputValue]);

  const handleDateChange = (newDate: Moment | null | undefined) => {

    const newFieldValue = newDate ? newDate.format(dateFormat) : null;
    setDate(newDate ?? null);
    dispatch({
      type: "UPDATE_FIELD",
      payload: {
        propertyKey,
        newFieldValue,
        rowIndex,
        propertySubKey,
        selectedTabSectionKey,
        isDialogField,
      },
    });
  };

  const handleDateClear = () => {
    setDate(null);
    dispatch({
      type: "UPDATE_FIELD",
      payload: {
        propertyKey,
        newFieldValue: null,
        rowIndex,
        propertySubKey,
        selectedTabSectionKey,
        isDialogField,
      },
    });
  };

  const id =
    rowIndex !== undefined && propertySubKey
      ? `-${rowIndex}-${propertySubKey}`
      : "";
  const formattedId = `${propertyKey}${id}-input`;

  return (
    <DatePicker
      allowDaysInPast
      dataTestId={formattedId}
      id={formattedId}
      label={title}
      name={propertyKey}
      date={date || null}
      numberOfMonths={1}
      dateFormat={dateFormat}
      blockedDateRanges={
        evalMethod ? getCustomBlockedCalendarDates(evalMethod) : []
      }
      dateInputProps={{
        onInputClear: handleDateClear,
        isRequired: isRequired && !isDisabled,
        errorMessage: message || "Invalid Date",
        hasError: error,
        onError: () => {
          // TODO: Handle error
        },
        isDisabled: isDisabled,
      }}
      onDateChange={handleDateChange}
    />
  );
}
